import angular from 'angular';
import constants from 'app/constants';
import { default as orgDataService } from 'app/services/data/org.data.service';
import { default as userService } from 'app/services/membership/ss.user.service';
import { default as authorizationService } from 'app/services/membership/ss.authorization.service';
import directive from './application-notifications.directive';
import controller from './application-notifications.directive.controller';
import clearNotificationsDialog from './dialog.clearNotificationsDialog';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export default angular.module('app.components.global.applicationNotifications', [
  orgDataService,
  userService,
  constants,
  authorizationService,
  clearNotificationsDialog,
  ssDialogService,
])
  .directive('applicationNotifications', directive)
  .controller('ApplicationNotificationsDirectiveController', controller)
  .name;

console.log('app.components.global.applicationNotifications created');
